/**
 * Mobile Menu Module
 * 
 * @package KateMedia
 */

export function initMobileMenu() {
    const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
    const mobileMenu = document.querySelector('.mobile-menu');
    const body = document.body;
    const html = document.documentElement;

    // Функция для управления overflow на html элементе
    function toggleHtmlOverflow(isOpen) {
        if (isOpen) {
            html.style.overflow = 'hidden';
        } else {
            html.style.overflow = '';
        }
    }

    if (mobileMenuToggle && mobileMenu) {
        mobileMenuToggle.addEventListener('click', function() {
            const isActive = mobileMenu.classList.toggle('active');
            body.classList.toggle('menu-open');
            toggleHtmlOverflow(isActive);
            
            const icon = this.querySelector('.mobile-menu-toggle__icon');
            if (icon) {
                icon.classList.toggle('active');
            }
        });

        const menuLinks = mobileMenu.querySelectorAll('a');
        menuLinks.forEach(link => {
            link.addEventListener('click', function() {
                mobileMenu.classList.remove('active');
                body.classList.remove('menu-open');
                toggleHtmlOverflow(false);
                
                const icon = mobileMenuToggle.querySelector('.mobile-menu-toggle__icon');
                if (icon) {
                    icon.classList.remove('active');
                }
            });
        });

        document.addEventListener('click', function(event) {
            if (mobileMenu && mobileMenuToggle) {
                if (!mobileMenu.contains(event.target) && !mobileMenuToggle.contains(event.target)) {
                    mobileMenu.classList.remove('active');
                    body.classList.remove('menu-open');
                    toggleHtmlOverflow(false);
                    
                    const icon = mobileMenuToggle.querySelector('.mobile-menu-toggle__icon');
                    if (icon) {
                        icon.classList.remove('active');
                    }
                }
            }
        });
    }
}
